import { React, useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import XLSX from 'sheetjs-style';

// material
import {
    Card,
    IconButton,
    Stack,
    Button,
    TextField,
    Divider,
    FormControl,
    MenuItem,
    InputLabel, Select,
    Autocomplete,
    Tooltip,
    Menu,
    Grid,
    Box,
    Typography
} from '@mui/material';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip as RechartsTooltip,
    ResponsiveContainer,
} from 'recharts';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import FilterListIcon from '@mui/icons-material/FilterList';
import RefreshIcon from '@mui/icons-material/Refresh';
import GetAppIcon from '@mui/icons-material/GetApp';
import {
    startOfMonth,
    endOfMonth,
    subMonths,
    startOfQuarter,
    endOfQuarter,
    subQuarters,
    startOfYear,
    endOfYear,
    format,
} from 'date-fns';
import { useSnackbar } from 'notistack';
import Moment from 'moment';
import { Icon } from '@iconify/react';
import * as FileSaver from 'file-saver';
import Iconify from '../../Iconify';
import URLS from '../../../services/urls.service';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import Page from '../../Page';
import { handleError } from '../../Common/Utils';
import AppCache from '../../../services/AppCache';

// ----------------------------------------------------------------------



// ----------------------------------------------------------------------
export default function ServiceRequestStatistics() {
    const periodDropdown = [
        { Id: 0, value: 'Current Month' },
        { Id: 1, value: 'Previous Month' },
        { Id: 2, value: 'Current Quarter' },
        { Id: 3, value: 'Previous Quarter' },
        { Id: 4, value: 'Current Year' },
        { Id: 5, value: 'Define Date' },
    ];
  
    const { enqueueSnackbar } = useSnackbar();
    const location = useLocation();
    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();

    const [currentTrackerId, setCurrentTrackerId] = useState('');
    const [trackerId, setTrcakerId] = useState('');
    const [selectedTrackerId, setSelectedTrackerId] = useState([]);

    const [control, setControl] = useState('');
    const [selectControl, setSelectControl] = useState([]);

    const [effectiveFromValue, setEffectiveFromValue] = useState(null);
    const [effectiveToValue, setEffectiveToValue] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    const [reports, setReports] = useState([]);
    const [columns, setColumns] = useState([]);
    const [isLoading, setIsLoading] = useState();
    const [pageSize, setPageSize] = useState(25);
    const [periodValue, setPeriodValue] = useState('');
    const [userId, setUserId] = useState([]);
    const [userName, setUserName] = useState([]);
    const [columnName, setColumnName] = useState('');
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [graphData, setGraphData] = useState([]);

    const navigate = useNavigate();

    const handleEffFrom = (newValue) => {
        setEffectiveFromValue(newValue)
    };
    const handleEffTo = (newValue) => {
        setEffectiveToValue(newValue)
    };
  
    const handleControl = (event) => {
        setControl( event.target.value)
    }
    console.log("control>>>>>>", control, reports)

    const onGenerateClick = () => {
        if (!periodValue) {
            enqueueSnackbar("Please select Period",);
            return;
        }
        if (!control) {
            enqueueSnackbar("Please select Controls",);
            return;
        }

        if (isVisible && !trackerId) {
            enqueueSnackbar("Please select Tracker Id Statistics",);
            return;
        }

        if (!isVisible && !currentTrackerId) {
            enqueueSnackbar("Please select Tracker Id Statistics",);
            return;
        }
        const today = new Date();
        let fromDate = null;
        let toDate = null;

        switch (periodValue) {
            case 'Current Month': {
                fromDate = startOfMonth(today);
                toDate = endOfMonth(today);
                break;
            }

            case 'Previous Month': {
                const prevMonth = subMonths(today, 1);
                fromDate = startOfMonth(prevMonth);
                toDate = endOfMonth(prevMonth);
                break;
            }

            case 'Current Quarter': {
                fromDate = startOfQuarter(today);
                toDate = endOfQuarter(today);
                break;
            }

            case 'Previous Quarter': {
                const prevQuarter = subQuarters(today, 1);
                fromDate = startOfQuarter(prevQuarter);
                toDate = endOfQuarter(prevQuarter);
                break;
            }

            case 'Current Year': {
                fromDate = startOfYear(today);
                toDate = endOfYear(today);
                break;
            }

            default: {
                fromDate = effectiveFromValue;
                toDate = effectiveToValue;
                break;
            }
        }

        const formattedFromDate = format(fromDate, 'yyyy-MM-dd');
        const formattedToDate = format(toDate, 'yyyy-MM-dd');

        // Payload
        const payload = {
            UserId: Number(CurrentLoggedInUser.ExecutiveId),
            TrackerId: currentTrackerId || trackerId,
            FromDate: formattedFromDate,
            ToDate: formattedToDate,
            TrackerSummaryColumnName: control || "",
        };
     

        // Set loading state to true
        setIsLoading(true);

        // API Call
        URLS.getTrackerRequestSummaryReport(payload)
            .then((response) => {
              
                if (response?.data && response?.data.length > 0) {
                    const dynamicColumns = Object.keys(response.data[0]).map((key) => {
                        const isSummarisedBy = key === "Summarised By";

                        return {
                            field: key,
                            headerName: key,
                            flex: isSummarisedBy ? 1 : 0.5,
                            minWidth: isSummarisedBy ? 150 : 100, 
                            align: isSummarisedBy ? 'left' : 'right',
                            headerAlign: isSummarisedBy ? 'left' : 'right',
                            renderCell: isSummarisedBy
                                ? (params) => (
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            const linkPayload = {
                                                ColName: control,
                                                ColValue: params.value,
                                                TrackerId: currentTrackerId || trackerId,
                                                FromDate: formattedFromDate,
                                                ToDate: formattedToDate,
                                                UserId: CurrentLoggedInUser.ExecutiveId

                                            };

                                            setIsLoading(true);
                                            URLS.linkServiceStatisticReport(linkPayload)
                                                .then((response) => {
                                                    setIsLoading(false);
                                                    navigate('/dashboard/servicerequeststatisticdetailspage', {
                                                        state: {
                                                            rowData: Array.isArray(response.data) ? response.data : [],
                                                            trackerId: currentTrackerId || trackerId,
                                                            controlName: control,
                                                            controlValue: params.value,
                                                        },
                                                    });
                                                })
                                                .catch(() => {
                                                    enqueueSnackbar("Record not found");
                                                    setIsLoading(false);
                                                });
                                        }}
                                        style={{
                                            all: 'unset',
                                            color: 'blue',
                                            textDecoration: 'underline',
                                            cursor: 'pointer',
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word',
                                        }}
                                    >
                                        {params.value}
                                    </button>
                                )
                                : undefined,
                        };
                    });

                    setColumns(dynamicColumns);
                    setReports(response.data);
                    enqueueSnackbar("Records Fetched successfully", { variant: 'success' });

                } else {
                    setReports([]);
                    setColumns([]);

                }
                setIsLoading(false);
            })
            .catch(error => {
                enqueueSnackbar("Record not found", { variant: 'success' });
                setReports([]);
                setColumns([]);
                setIsLoading(false);
            });
       
    };

    const handleTrackerId = (event) => {
        const id = event.target.value;
        setTrcakerId(id);

        URLS.getTackerSummaryApplicableCotrols({ TrackerId: id })
            .then((response) => {
                setSelectControl(response.data || []);

            })
            .catch((error) => {
                setSelectControl([]);
                console.log("Error:", error);
            });
        URLS.graphServiceStatisticReport({
            UserId: CurrentLoggedInUser.ExecutiveId,
            TrackerId: currentTrackerId || trackerId,

        })
            .then((res) => {
                setGraphData(res.data || []);
            })
            .catch(() => {
                setGraphData([]);
            })

    };

    
    // Reset
    const onResetClick = () => {
        setEffectiveFromValue(null);
        setEffectiveToValue(null);
        setReports([]);
        setColumns([]);
        setControl('');
        setTrcakerId('');
        setPeriodValue('');

    }
    const exportToExcel = () => {
        const fileExtension = '.xlsx';
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

        // Check if reports are available
        if (!reports || reports.length === 0) {
            console.log("No data to export.");
            return;
        }

        // Prepare headers based on response keys
        const headers = Object.keys(reports[0]);

        // Prepare the row data based on reports data
        const dataToExport = reports.map((row) => {
            return headers.map(header => row[header]); // Map each header to the corresponding row data
        });

        const dataWithHeaders = [headers, ...dataToExport]; // Combine headers with data rows
        const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders); // Convert to AOA format

        const wb = { Sheets: { data: ws }, SheetNames: ['data'] }; // Create workbook

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' }); // Write workbook to buffer
        const data = new Blob([excelBuffer], { type: fileType }); // Create a blob from the buffer
        const timestamp = Moment().format('DD-MMM-YYYY_HH-mm');
        const fileName = `${userName}_ServiceRequestStatistics_${timestamp}${fileExtension}`; // Define file name

        FileSaver.saveAs(data, fileName); // Save the file
    };
    useEffect(() => {
      
        setUserId(CurrentLoggedInUser.ExecutiveId);
        setUserName(CurrentLoggedInUser.ExecutiveName);

            URLS.getTrackerMasterData({ UserId: CurrentLoggedInUser.ExecutiveId })
                .then((response) => {
                    setSelectedTrackerId(response.data || [])

                    if (Array.isArray(response.data) && response.data.length === 1) {
                        setIsVisible(false);
                        setCurrentTrackerId(response.data[0].TrackerMasterID)
                        const trackerId = response.data[0].TrackerMasterID
                        URLS.getTackerSummaryApplicableCotrols({ TrackerId: trackerId })
                            .then((summaryResponse) => {
                                setSelectControl(summaryResponse.data || []);
                                URLS.graphServiceStatisticReport({
                                    UserId: CurrentLoggedInUser.ExecutiveId,
                                    TrackerId: currentTrackerId || trackerId,
                              
                                })
                                    .then((res) => {
                                        setGraphData(res.data || []);
                                    })
                                    .catch(() => {
                                        setGraphData([]);
                                    })

                            })
                            .catch((error) => {
                                setSelectControl([]);
                                console.log("Error:", error);
                            });
                    } else {
                        setIsVisible(true);
                    }
                })
                .catch(error => {
                    // On error
                    setSelectControl([])
                    console.log(" Error ");
                });
       

    }, []);  // Add userId to the dependency array

    useEffect(() => {
        setEffectiveFromValue(null);
        setEffectiveToValue(null);
        setReports([]);
        setColumns([]);
        setControl('');
        setTrcakerId('');
        setPeriodValue('');
    }, [location.key]);
    console.log(">>>>>>>>>>>>>>>>>>>>>trackerId", trackerId)
    return (

        <Page title="Service Request Statistics"  >
            <Box display="flex" justifyContent="space-between" alignItems="center" px={3} my={1}>
                <Typography variant="h5" sx={{ fontFamily: 'Inter, sans-serif' }}>
                    Service Request Statistics
                </Typography>

                <Button
                    variant="outlined"
                    sx={{
                        color: '#930F00',
                        borderColor: '#930F00',
                        fontFamily: 'Inter, sans-serif' 
                    }}
                    startIcon={<GetAppIcon />}
                    onClick={exportToExcel }
                >
                    Export
                </Button>
            </Box>
            <Divider />

            <Card sx={{ p: 2 }}>
                <Grid container spacing={2}>
                    {/* Left - Bar Graph */}
                    <Grid item xs={12} md={3}>
                        <Card sx={{ height: 350, p: 2 }}>
                            <Typography variant="h6" textAlign="center" color="text.secondary" gutterBottom sx={{ fontFamily: 'Inter, sans-serif' }}>
                                Issue Analysis
                            </Typography>

                            <ResponsiveContainer width="100%" height={250}>
                                <BarChart
                                    data={graphData}
                                    margin={{ top: 10, right: 30, left: 0, bottom: 20 }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="Month" interval={0} tick={{
                                        angle: -45,
                                        textAnchor: 'end',
                                        fontFamily: 'Inter, sans-serif',
                                        fontSize: 11,
                                    }}
                                        height={60} />
                                    <YAxis ticks={[0, 5, 10, 15, 20]} />
                                    <RechartsTooltip />
                                    <Bar dataKey="IssueCount" fill="#3f51b5" barSize={15} />
                                </BarChart>
                            </ResponsiveContainer>

                            <Box sx={{ textAlign: 'center', mt: 1 }}>
                                <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Inter, sans-serif' }}>
                                    Issues 
                                </Typography>
                            </Box>
                        </Card>
                       
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        md={0.2}
                        sx={{
                            display: { xs: 'none', md: 'flex' },
                            justifyContent: 'center',
                            alignItems: 'stretch',
                            px: 0,
                        }}
                    >
                        <Divider orientation="vertical" flexItem sx={{ width: '1px', backgroundColor: '#ccc' }} />
                    </Grid>

                    <Grid item xs={12} md={8.8}>

                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                            <Stack
                                direction="row"
                                spacing={1}
                                flexWrap="wrap"
                                sx={{ flexGrow: 1, minWidth: 0 }}
                            >
                                {/* Period Selection */}
                                <FormControl size="small" sx={{ minWidth: 210, fontFamily: 'Inter, sans-serif' }}>
                                    <InputLabel sx={{ fontFamily: 'Inter, sans-serif' }}>Period Selection</InputLabel>
                                    <Select
                                        label="Period Selection"
                                        value={periodValue}
                                        onChange={(e) => setPeriodValue(e.target.value)}
                                        sx={{ fontFamily: 'Inter, sans-serif' }}
                                        MenuProps={{
                                            PaperProps: {
                                                sx: {
                                                    fontFamily: 'Inter, sans-serif',
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem value="" sx={{ fontFamily: 'Inter, sans-serif' }}>Select</MenuItem>
                                        {periodDropdown.map((item) => (
                                            <MenuItem key={item.Id} value={item.value} sx={{ fontFamily: 'Inter, sans-serif' }}>
                                                {item.value}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                {periodValue === 'Define Date' ? (
                                    <>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                label="From Date"
                                                inputFormat="dd/MMM/yyyy"
                                                value={effectiveFromValue}
                                                onChange={handleEffFrom}
                                                maxDate={new Date()}
                                                renderInput={(params) => (
                                                    <TextField size="small" {...params} sx={{ fontFamily: 'Inter, sans-serif' }} />
                                                )}
                                            />
                                        </LocalizationProvider>

                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                label="To Date"
                                                inputFormat="dd/MMM/yyyy"
                                                value={effectiveToValue}
                                                onChange={handleEffTo}
                                                disableFuture
                                                renderInput={(params) => (
                                                    <TextField size="small" {...params} sx={{ fontFamily: 'Inter, sans-serif' }} />
                                                )}
                                            />
                                        </LocalizationProvider>
                                    </>
                                ) : (
                                    <>
                                        <FormControl size="small" sx={{ minWidth: 210, fontFamily: 'Inter, sans-serif' }}>
                                            <InputLabel sx={{ fontFamily: 'Inter, sans-serif' }}>Summarised By</InputLabel>
                                            <Select
                                                label="Summarised By"
                                                value={control}
                                                onChange={handleControl}
                                                sx={{ fontFamily: 'Inter, sans-serif' }}
                                                MenuProps={{
                                                    PaperProps: {
                                                        sx: {
                                                            backgroundColor: '#fbe9e7',
                                                            maxHeight: '200px',
                                                            fontFamily: 'Inter, sans-serif',
                                                        },
                                                    },
                                                }}
                                            >
                                                <MenuItem value="" sx={{ fontFamily: 'Inter, sans-serif' }}>Select</MenuItem>
                                                {selectControl.map((item) => (
                                                    <MenuItem key={item.Id} value={item.ColumnName} sx={{ fontFamily: 'Inter, sans-serif' }}>
                                                        {item.DisplayName}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        {isVisible && (
                                            <FormControl size="small" sx={{ minWidth: 210, fontFamily: 'Inter, sans-serif' }}>
                                                <InputLabel sx={{ fontFamily: 'Inter, sans-serif' }}>Tracker</InputLabel>
                                                <Select
                                                    label="Tracker"
                                                    value={trackerId}
                                                    onChange={handleTrackerId}
                                                    sx={{ fontFamily: 'Inter, sans-serif' }}
                                                    MenuProps={{
                                                        PaperProps: {
                                                            sx: {
                                                                backgroundColor: '#fbe9e7',
                                                                maxHeight: '200px',
                                                                fontFamily: 'Inter, sans-serif',
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <MenuItem value="" sx={{ fontFamily: 'Inter, sans-serif' }}>Select</MenuItem>
                                                    {selectedTrackerId.map((tracker) => (
                                                        <MenuItem
                                                            key={tracker.TrackerMasterID}
                                                            value={tracker.TrackerMasterID}
                                                            sx={{ fontFamily: 'Inter, sans-serif' }}
                                                        >
                                                            {tracker.TrackerName}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        )}
                                    </>
                                )}
  
                            </Stack>

                            {/* Right side - buttons */}
                            <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
                                <Tooltip title="Generate">
                                    <Button variant="contained" size="small" onClick={onGenerateClick}>
                                        <Icon icon="ic:outline-filter-alt" width="25px" height="25px" />
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Reset">
                                    <Button variant="outlined" size="small" onClick={onResetClick}>
                                        <Icon icon="ic:twotone-restart-alt" width="25px" height="25px" />
                                    </Button>
                                </Tooltip>
                                </Stack>
                        </Box>

                        {/* Second row: Controller below if period is selected */}
                        {periodValue === 'Define Date' && (
                            <Box mb={2} pt={1}>
                                <Stack spacing={1} direction="row">
                                    <FormControl size="small" sx={{ minWidth: 210  ,fontFamily: 'Inter, sans-serif'}} >
                                        <InputLabel sx={{ fontFamily: 'Inter, sans-serif' }}>Summarised By</InputLabel>
                                        <Select
                                            label="Summarised By"
                                            value={control}
                                            onChange={handleControl}
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        backgroundColor: '#fbe9e7',
                                                        maxHeight: '200px',
                                                        fontFamily: 'Inter, sans-serif'
                                                    },
                                                },
                                            }}
                                        >
                                            <MenuItem value="">Select</MenuItem>
                                            {selectControl.map((item) => (
                                                <MenuItem key={item.Id} value={item.ColumnName}>
                                                    {item.DisplayName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                </FormControl>
                                {isVisible && (
                                        <FormControl size="small" sx={{ minWidth: 210,  fontFamily: 'Inter, sans-serif'  }} >
                                            <InputLabel sx={{ fontFamily: 'Inter, sans-serif' }}> Tracker </InputLabel>
                                        <Select
                                            label=" Tracker "
                                            value={trackerId}
                                            onChange={handleTrackerId}
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        backgroundColor: '#fbe9e7',
                                                        maxHeight: '200px',
                                                             fontFamily: 'Inter, sans-serif' 
                                                    },
                                                },
                                            }}
                                        >
                                            <MenuItem value="">Select</MenuItem>
                                            {selectedTrackerId.map((tracker) => (
                                                <MenuItem
                                                    key={tracker.TrackerMasterID}
                                                    value={tracker.TrackerMasterID}
                                                >
                                                    {tracker.TrackerName}
                                                </MenuItem>
                                            ))}

                                        </Select>
                                    </FormControl>
                                ) }
                                </Stack>
                            </Box>
                        )}

                        {/* Data Grid */}
                        <Card sx={{ height: 350, overflow: 'hidden' }}>
                            <DataGrid
                                rows={reports}
                                columns={columns}
                                getRowId={(row) => row.id || reports.indexOf(row)}
                                pageSize={pageSize}
                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                rowsPerPageOptions={[25, 50, 100]}
                                disableColumnMenu
                                hideFooter
                                density="compact"
                               
                                sx={{
                                    border: 0,
                                    width: '100%', 
                                    overflow: 'hidden',
                                    fontFamily: 'Inter, sans-serif',
                                    '& .MuiDataGrid-columnHeaders': {
                                        backgroundColor: '#fdecea', // soft pink
                                        color: '#555',               // softer text
                                        fontWeight: 100,             // regular font weight
                                        fontSize: '13px',
                                        whiteSpace: 'normal',
                                        wordBreak: 'break-word',
                                        lineHeight: 1.2,
                                        textAlign: 'center',
                                    },

                                    '& .MuiDataGrid-columnHeaderTitle': {
                                        whiteSpace: 'normal',
                                        lineHeight: '1.2',
                                    },
                                    '& .MuiDataGrid-cell': {
                                        borderBottom: '1px solid #f0f0f0',
                                        fontSize: '13px',
                                    },
                                    '& .MuiDataGrid-row': {
                                        maxHeight: '40px !important',
                                        minHeight: '40px !important',
                                    },
                                }}
                            />
                        </Card>
                    </Grid>

                </Grid>
            </Card>

            {isLoading && (<LoadingProgressBar sx={{ py: 6 }} />)}


        </Page>


    );
}